module.exports = __webpack_public_path__ + "mobile/img/img_question_banner.4dd65278.png";